import GlobalSearchCategory from '@/enumerations/global-search-categories';

export default [
	{
		text: 'Accounting',
		isParent: true,
		value: GlobalSearchCategory.Accounting,
		selected: false,
		areaTemplate: '',
		hasDivider: true,
		categories: [
			GlobalSearchCategory.JournalDetails,
			GlobalSearchCategory.Receipts,
			GlobalSearchCategory.PurchaseOrders,
			GlobalSearchCategory.AccountsPayable,
			GlobalSearchCategory.VehicleSales
		]
	},
	{
		text: 'All Categories',
		isParent: true,
		value: GlobalSearchCategory.All,
		selected: true,
		areaTemplate: '',
		categories: [
			GlobalSearchCategory.Customers,
			GlobalSearchCategory.CustomerPhoneNumbers,
			GlobalSearchCategory.Deals,
			GlobalSearchCategory.Desks,
			GlobalSearchCategory.PartsInvoices,
			GlobalSearchCategory.Prospects,
			GlobalSearchCategory.Appointments,
			GlobalSearchCategory.RepairOrders,
			GlobalSearchCategory.Vehicles,
			GlobalSearchCategory.Vendors
		]
	},
	{
		text: 'Appointments',
		isParent: false,
		value: GlobalSearchCategory.Appointments,
		selected: false
	},
	{
		text: 'Customers',
		isParent: false,
		value: GlobalSearchCategory.Customers,
		selected: false
	},
	{
		text: 'Deals',
		isParent: false,
		value: GlobalSearchCategory.Deals,
		selected: false
	},
	{
		text: 'Desks',
		isParent: false,
		value: GlobalSearchCategory.Desks,
		selected: false
	},
	{
		text: 'Parts Invoices',
		isParent: false,
		value: GlobalSearchCategory.PartsInvoices,
		selected: false
	},
	{
		text: 'Customer Phone Numbers',
		isParent: false,
		value: GlobalSearchCategory.CustomerPhoneNumbers,
		selected: false
	},
	{
		text: 'Prospects',
		isParent: false,
		value: GlobalSearchCategory.Prospects,
		selected: false
	},
	{
		text: 'Repair Orders',
		isParent: false,
		value: GlobalSearchCategory.RepairOrders,
		selected: false
	},
	{
		text: 'Vehicles',
		isParent: false,
		value: GlobalSearchCategory.Vehicles,
		selected: false
	},
	{
		text: 'Vendors',
		isParent: false,
		value: GlobalSearchCategory.Vendors,
		selected: false
	}
];
